import styles from './styles.module.css';
import EmptyState from '@/components/EmptyState';

function HistoryContainer() {
  return (
    <div className={styles.mainContainer}>
      <EmptyState
        title={`It seems you don't have any
    Turbine assigned yet.`}
        subtitle="Please contact your administrator."
      />
    </div>
  );
}

export default HistoryContainer;
